// source: vnf/vnf.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var asset_util_pb = require('../asset/util_pb.js');
goog.object.extend(proto, asset_util_pb);
var asset_network_pb = require('../asset/network_pb.js');
goog.object.extend(proto, asset_network_pb);
var asset_managedNode_pb = require('../asset/managedNode_pb.js');
goog.object.extend(proto, asset_managedNode_pb);
var asset_task_pb = require('../asset/task_pb.js');
goog.object.extend(proto, asset_task_pb);
goog.exportSymbol('proto.vnf.Account', null, global);
goog.exportSymbol('proto.vnf.AccountListResponse', null, global);
goog.exportSymbol('proto.vnf.AccountRequest', null, global);
goog.exportSymbol('proto.vnf.AccountResponse', null, global);
goog.exportSymbol('proto.vnf.BoardNetwork', null, global);
goog.exportSymbol('proto.vnf.BoardNetworkListResponse', null, global);
goog.exportSymbol('proto.vnf.ContinuousScanTask', null, global);
goog.exportSymbol('proto.vnf.ContinuousScanTaskListResponse', null, global);
goog.exportSymbol('proto.vnf.ContinuousScanTaskResponse', null, global);
goog.exportSymbol('proto.vnf.CreateAccountRequest', null, global);
goog.exportSymbol('proto.vnf.CreateAccountResponse', null, global);
goog.exportSymbol('proto.vnf.CreateScanTaskRequest', null, global);
goog.exportSymbol('proto.vnf.GetContinuousScanTaskRequest', null, global);
goog.exportSymbol('proto.vnf.GetListAccountRequest', null, global);
goog.exportSymbol('proto.vnf.GetListBoardNetworkRequest', null, global);
goog.exportSymbol('proto.vnf.GetListContinuousScanTaskRequest', null, global);
goog.exportSymbol('proto.vnf.ManagedNodeListResponse', null, global);
goog.exportSymbol('proto.vnf.ManagedNodeUserInfoRequest', null, global);
goog.exportSymbol('proto.vnf.ManagedNodeUserInfoResponse', null, global);
goog.exportSymbol('proto.vnf.ManagedNodeWithStatus', null, global);
goog.exportSymbol('proto.vnf.NodePrivilege', null, global);
goog.exportSymbol('proto.vnf.NodePrivilegeListResponse', null, global);
goog.exportSymbol('proto.vnf.NodePrivilegeUpdate', null, global);
goog.exportSymbol('proto.vnf.NodePrivilegeUpdateResult', null, global);
goog.exportSymbol('proto.vnf.NodePrivilegeUpdateResultListResponse', null, global);
goog.exportSymbol('proto.vnf.ScanConfig', null, global);
goog.exportSymbol('proto.vnf.SubmitSupportInquiryRequest', null, global);
goog.exportSymbol('proto.vnf.UpdateAccountNodePrivilegeRequest', null, global);
goog.exportSymbol('proto.vnf.UpdateAccountRequest', null, global);
goog.exportSymbol('proto.vnf.UpdateAccountResponse', null, global);
goog.exportSymbol('proto.vnf.UpdateListZabbixHostRequest', null, global);
goog.exportSymbol('proto.vnf.UpdateListZabbixHostResponse', null, global);
goog.exportSymbol('proto.vnf.UpdateManagedNodeUserInfoRequest', null, global);
goog.exportSymbol('proto.vnf.UserInfo', null, global);
goog.exportSymbol('proto.vnf.UserInfo.Employee', null, global);
goog.exportSymbol('proto.vnf.ZabbixHost', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UserInfo.displayName = 'proto.vnf.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UserInfo.Employee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UserInfo.Employee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UserInfo.Employee.displayName = 'proto.vnf.UserInfo.Employee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ManagedNodeWithStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ManagedNodeWithStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ManagedNodeWithStatus.displayName = 'proto.vnf.ManagedNodeWithStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ZabbixHost = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ZabbixHost, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ZabbixHost.displayName = 'proto.vnf.ZabbixHost';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.NodePrivilege = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.NodePrivilege, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.NodePrivilege.displayName = 'proto.vnf.NodePrivilege';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.NodePrivilegeUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.NodePrivilegeUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.NodePrivilegeUpdate.displayName = 'proto.vnf.NodePrivilegeUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.NodePrivilegeUpdateResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.NodePrivilegeUpdateResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.NodePrivilegeUpdateResult.displayName = 'proto.vnf.NodePrivilegeUpdateResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.Account.displayName = 'proto.vnf.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ScanConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ScanConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ScanConfig.displayName = 'proto.vnf.ScanConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ContinuousScanTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ContinuousScanTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ContinuousScanTask.displayName = 'proto.vnf.ContinuousScanTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.BoardNetwork = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.BoardNetwork, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.BoardNetwork.displayName = 'proto.vnf.BoardNetwork';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateListZabbixHostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.UpdateListZabbixHostRequest.repeatedFields_, null);
};
goog.inherits(proto.vnf.UpdateListZabbixHostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateListZabbixHostRequest.displayName = 'proto.vnf.UpdateListZabbixHostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.SubmitSupportInquiryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.SubmitSupportInquiryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.SubmitSupportInquiryRequest.displayName = 'proto.vnf.SubmitSupportInquiryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ManagedNodeUserInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ManagedNodeUserInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ManagedNodeUserInfoRequest.displayName = 'proto.vnf.ManagedNodeUserInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateManagedNodeUserInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UpdateManagedNodeUserInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateManagedNodeUserInfoRequest.displayName = 'proto.vnf.UpdateManagedNodeUserInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.GetListAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.GetListAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.GetListAccountRequest.displayName = 'proto.vnf.GetListAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateAccountNodePrivilegeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.UpdateAccountNodePrivilegeRequest.repeatedFields_, null);
};
goog.inherits(proto.vnf.UpdateAccountNodePrivilegeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateAccountNodePrivilegeRequest.displayName = 'proto.vnf.UpdateAccountNodePrivilegeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.AccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.AccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.AccountRequest.displayName = 'proto.vnf.AccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.CreateAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.CreateAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.CreateAccountRequest.displayName = 'proto.vnf.CreateAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UpdateAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateAccountRequest.displayName = 'proto.vnf.UpdateAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.CreateScanTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.CreateScanTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.CreateScanTaskRequest.displayName = 'proto.vnf.CreateScanTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.GetListContinuousScanTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.GetListContinuousScanTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.GetListContinuousScanTaskRequest.displayName = 'proto.vnf.GetListContinuousScanTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.GetContinuousScanTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.GetContinuousScanTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.GetContinuousScanTaskRequest.displayName = 'proto.vnf.GetContinuousScanTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.GetListBoardNetworkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.GetListBoardNetworkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.GetListBoardNetworkRequest.displayName = 'proto.vnf.GetListBoardNetworkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ManagedNodeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.ManagedNodeListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.ManagedNodeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ManagedNodeListResponse.displayName = 'proto.vnf.ManagedNodeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateListZabbixHostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UpdateListZabbixHostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateListZabbixHostResponse.displayName = 'proto.vnf.UpdateListZabbixHostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ManagedNodeUserInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ManagedNodeUserInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ManagedNodeUserInfoResponse.displayName = 'proto.vnf.ManagedNodeUserInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.NodePrivilegeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.NodePrivilegeListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.NodePrivilegeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.NodePrivilegeListResponse.displayName = 'proto.vnf.NodePrivilegeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.NodePrivilegeUpdateResultListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.NodePrivilegeUpdateResultListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.NodePrivilegeUpdateResultListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.NodePrivilegeUpdateResultListResponse.displayName = 'proto.vnf.NodePrivilegeUpdateResultListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.AccountListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.AccountListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.AccountListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.AccountListResponse.displayName = 'proto.vnf.AccountListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.AccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.AccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.AccountResponse.displayName = 'proto.vnf.AccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.CreateAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.CreateAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.CreateAccountResponse.displayName = 'proto.vnf.CreateAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.UpdateAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.UpdateAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.UpdateAccountResponse.displayName = 'proto.vnf.UpdateAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ContinuousScanTaskListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.ContinuousScanTaskListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.ContinuousScanTaskListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ContinuousScanTaskListResponse.displayName = 'proto.vnf.ContinuousScanTaskListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.ContinuousScanTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vnf.ContinuousScanTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.ContinuousScanTaskResponse.displayName = 'proto.vnf.ContinuousScanTaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vnf.BoardNetworkListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vnf.BoardNetworkListResponse.repeatedFields_, null);
};
goog.inherits(proto.vnf.BoardNetworkListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vnf.BoardNetworkListResponse.displayName = 'proto.vnf.BoardNetworkListResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
department: jspb.Message.getFieldWithDefault(msg, 2, ""),
vpnAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
employee: (f = msg.getEmployee()) && proto.vnf.UserInfo.Employee.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UserInfo}
 */
proto.vnf.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UserInfo;
  return proto.vnf.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UserInfo}
 */
proto.vnf.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVpnAccount(value);
      break;
    case 10:
      var value = new proto.vnf.UserInfo.Employee;
      reader.readMessage(value,proto.vnf.UserInfo.Employee.deserializeBinaryFromReader);
      msg.setEmployee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVpnAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmployee();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.vnf.UserInfo.Employee.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UserInfo.Employee.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UserInfo.Employee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UserInfo.Employee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UserInfo.Employee.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
department: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UserInfo.Employee}
 */
proto.vnf.UserInfo.Employee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UserInfo.Employee;
  return proto.vnf.UserInfo.Employee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UserInfo.Employee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UserInfo.Employee}
 */
proto.vnf.UserInfo.Employee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UserInfo.Employee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UserInfo.Employee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UserInfo.Employee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UserInfo.Employee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.vnf.UserInfo.Employee.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo.Employee} returns this
 */
proto.vnf.UserInfo.Employee.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.vnf.UserInfo.Employee.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo.Employee} returns this
 */
proto.vnf.UserInfo.Employee.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string department = 3;
 * @return {string}
 */
proto.vnf.UserInfo.Employee.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo.Employee} returns this
 */
proto.vnf.UserInfo.Employee.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.vnf.UserInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo} returns this
 */
proto.vnf.UserInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string department = 2;
 * @return {string}
 */
proto.vnf.UserInfo.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo} returns this
 */
proto.vnf.UserInfo.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vpn_account = 3;
 * @return {string}
 */
proto.vnf.UserInfo.prototype.getVpnAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UserInfo} returns this
 */
proto.vnf.UserInfo.prototype.setVpnAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Employee employee = 10;
 * @return {?proto.vnf.UserInfo.Employee}
 */
proto.vnf.UserInfo.prototype.getEmployee = function() {
  return /** @type{?proto.vnf.UserInfo.Employee} */ (
    jspb.Message.getWrapperField(this, proto.vnf.UserInfo.Employee, 10));
};


/**
 * @param {?proto.vnf.UserInfo.Employee|undefined} value
 * @return {!proto.vnf.UserInfo} returns this
*/
proto.vnf.UserInfo.prototype.setEmployee = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.UserInfo} returns this
 */
proto.vnf.UserInfo.prototype.clearEmployee = function() {
  return this.setEmployee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.UserInfo.prototype.hasEmployee = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ManagedNodeWithStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ManagedNodeWithStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ManagedNodeWithStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeWithStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
managedNode: (f = msg.getManagedNode()) && asset_managedNode_pb.ManagedNode.toObject(includeInstance, f),
statusZabbixHost: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
userInfo: (f = msg.getUserInfo()) && proto.vnf.UserInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ManagedNodeWithStatus}
 */
proto.vnf.ManagedNodeWithStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ManagedNodeWithStatus;
  return proto.vnf.ManagedNodeWithStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ManagedNodeWithStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ManagedNodeWithStatus}
 */
proto.vnf.ManagedNodeWithStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_managedNode_pb.ManagedNode;
      reader.readMessage(value,asset_managedNode_pb.ManagedNode.deserializeBinaryFromReader);
      msg.setManagedNode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatusZabbixHost(value);
      break;
    case 3:
      var value = new proto.vnf.UserInfo;
      reader.readMessage(value,proto.vnf.UserInfo.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ManagedNodeWithStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ManagedNodeWithStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ManagedNodeWithStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeWithStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagedNode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_managedNode_pb.ManagedNode.serializeBinaryToWriter
    );
  }
  f = message.getStatusZabbixHost();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vnf.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional asset.ManagedNode managed_node = 1;
 * @return {?proto.asset.ManagedNode}
 */
proto.vnf.ManagedNodeWithStatus.prototype.getManagedNode = function() {
  return /** @type{?proto.asset.ManagedNode} */ (
    jspb.Message.getWrapperField(this, asset_managedNode_pb.ManagedNode, 1));
};


/**
 * @param {?proto.asset.ManagedNode|undefined} value
 * @return {!proto.vnf.ManagedNodeWithStatus} returns this
*/
proto.vnf.ManagedNodeWithStatus.prototype.setManagedNode = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ManagedNodeWithStatus} returns this
 */
proto.vnf.ManagedNodeWithStatus.prototype.clearManagedNode = function() {
  return this.setManagedNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ManagedNodeWithStatus.prototype.hasManagedNode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool status_zabbix_host = 2;
 * @return {boolean}
 */
proto.vnf.ManagedNodeWithStatus.prototype.getStatusZabbixHost = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.ManagedNodeWithStatus} returns this
 */
proto.vnf.ManagedNodeWithStatus.prototype.setStatusZabbixHost = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional UserInfo user_info = 3;
 * @return {?proto.vnf.UserInfo}
 */
proto.vnf.ManagedNodeWithStatus.prototype.getUserInfo = function() {
  return /** @type{?proto.vnf.UserInfo} */ (
    jspb.Message.getWrapperField(this, proto.vnf.UserInfo, 3));
};


/**
 * @param {?proto.vnf.UserInfo|undefined} value
 * @return {!proto.vnf.ManagedNodeWithStatus} returns this
*/
proto.vnf.ManagedNodeWithStatus.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ManagedNodeWithStatus} returns this
 */
proto.vnf.ManagedNodeWithStatus.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ManagedNodeWithStatus.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ZabbixHost.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ZabbixHost.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ZabbixHost} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ZabbixHost.toObject = function(includeInstance, msg) {
  var f, obj = {
managedNodeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ZabbixHost}
 */
proto.vnf.ZabbixHost.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ZabbixHost;
  return proto.vnf.ZabbixHost.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ZabbixHost} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ZabbixHost}
 */
proto.vnf.ZabbixHost.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ZabbixHost.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ZabbixHost.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ZabbixHost} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ZabbixHost.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string managed_node_id = 1;
 * @return {string}
 */
proto.vnf.ZabbixHost.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ZabbixHost} returns this
 */
proto.vnf.ZabbixHost.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool status = 2;
 * @return {boolean}
 */
proto.vnf.ZabbixHost.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.ZabbixHost} returns this
 */
proto.vnf.ZabbixHost.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.NodePrivilege.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.NodePrivilege.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.NodePrivilege} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilege.toObject = function(includeInstance, msg) {
  var f, obj = {
boardId: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
networkName: jspb.Message.getFieldWithDefault(msg, 3, ""),
managedNodeId: jspb.Message.getFieldWithDefault(msg, 4, ""),
managedNodeName: jspb.Message.getFieldWithDefault(msg, 5, ""),
userInfo: (f = msg.getUserInfo()) && proto.vnf.UserInfo.toObject(includeInstance, f),
allowed: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.NodePrivilege}
 */
proto.vnf.NodePrivilege.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.NodePrivilege;
  return proto.vnf.NodePrivilege.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.NodePrivilege} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.NodePrivilege}
 */
proto.vnf.NodePrivilege.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeName(value);
      break;
    case 6:
      var value = new proto.vnf.UserInfo;
      reader.readMessage(value,proto.vnf.UserInfo.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.NodePrivilege.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.NodePrivilege.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.NodePrivilege} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilege.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNetworkName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManagedNodeName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.vnf.UserInfo.serializeBinaryToWriter
    );
  }
  f = message.getAllowed();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string board_id = 1;
 * @return {string}
 */
proto.vnf.NodePrivilege.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.vnf.NodePrivilege.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string network_name = 3;
 * @return {string}
 */
proto.vnf.NodePrivilege.prototype.getNetworkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setNetworkName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string managed_node_id = 4;
 * @return {string}
 */
proto.vnf.NodePrivilege.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string managed_node_name = 5;
 * @return {string}
 */
proto.vnf.NodePrivilege.prototype.getManagedNodeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setManagedNodeName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional UserInfo user_info = 6;
 * @return {?proto.vnf.UserInfo}
 */
proto.vnf.NodePrivilege.prototype.getUserInfo = function() {
  return /** @type{?proto.vnf.UserInfo} */ (
    jspb.Message.getWrapperField(this, proto.vnf.UserInfo, 6));
};


/**
 * @param {?proto.vnf.UserInfo|undefined} value
 * @return {!proto.vnf.NodePrivilege} returns this
*/
proto.vnf.NodePrivilege.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.NodePrivilege.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool allowed = 7;
 * @return {boolean}
 */
proto.vnf.NodePrivilege.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.NodePrivilege} returns this
 */
proto.vnf.NodePrivilege.prototype.setAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.NodePrivilegeUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.NodePrivilegeUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.NodePrivilegeUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
boardId: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
managedNodeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
allowed: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.NodePrivilegeUpdate}
 */
proto.vnf.NodePrivilegeUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.NodePrivilegeUpdate;
  return proto.vnf.NodePrivilegeUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.NodePrivilegeUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.NodePrivilegeUpdate}
 */
proto.vnf.NodePrivilegeUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.NodePrivilegeUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.NodePrivilegeUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.NodePrivilegeUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAllowed();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string board_id = 1;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdate.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdate} returns this
 */
proto.vnf.NodePrivilegeUpdate.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdate.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdate} returns this
 */
proto.vnf.NodePrivilegeUpdate.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string managed_node_id = 3;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdate.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdate} returns this
 */
proto.vnf.NodePrivilegeUpdate.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool allowed = 4;
 * @return {boolean}
 */
proto.vnf.NodePrivilegeUpdate.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.NodePrivilegeUpdate} returns this
 */
proto.vnf.NodePrivilegeUpdate.prototype.setAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.NodePrivilegeUpdateResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.NodePrivilegeUpdateResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdateResult.toObject = function(includeInstance, msg) {
  var f, obj = {
boardId: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
managedNodeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
errorMessage: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.NodePrivilegeUpdateResult}
 */
proto.vnf.NodePrivilegeUpdateResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.NodePrivilegeUpdateResult;
  return proto.vnf.NodePrivilegeUpdateResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.NodePrivilegeUpdateResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.NodePrivilegeUpdateResult}
 */
proto.vnf.NodePrivilegeUpdateResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.NodePrivilegeUpdateResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.NodePrivilegeUpdateResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdateResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string board_id = 1;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdateResult} returns this
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdateResult} returns this
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string managed_node_id = 3;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdateResult} returns this
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool success = 10;
 * @return {boolean}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.NodePrivilegeUpdateResult} returns this
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string error_message = 11;
 * @return {string}
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.NodePrivilegeUpdateResult} returns this
 */
proto.vnf.NodePrivilegeUpdateResult.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
admin: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
department: jspb.Message.getFieldWithDefault(msg, 5, ""),
superAdmin: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
creationTimestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
lastSignInTimestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
numberOfAllowedNodes: jspb.Message.getFieldWithDefault(msg, 9, 0),
numberOfAllowedEmployees: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.Account}
 */
proto.vnf.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.Account;
  return proto.vnf.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.Account}
 */
proto.vnf.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdmin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuperAdmin(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreationTimestamp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastSignInTimestamp(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfAllowedNodes(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfAllowedEmployees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdmin();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSuperAdmin();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCreationTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getLastSignInTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getNumberOfAllowedNodes();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getNumberOfAllowedEmployees();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vnf.Account.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool admin = 2;
 * @return {boolean}
 */
proto.vnf.Account.prototype.getAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.vnf.Account.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.vnf.Account.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string department = 5;
 * @return {string}
 */
proto.vnf.Account.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool super_admin = 6;
 * @return {boolean}
 */
proto.vnf.Account.prototype.getSuperAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setSuperAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 creation_timestamp = 7;
 * @return {number}
 */
proto.vnf.Account.prototype.getCreationTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setCreationTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 last_sign_in_timestamp = 8;
 * @return {number}
 */
proto.vnf.Account.prototype.getLastSignInTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setLastSignInTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 number_of_allowed_nodes = 9;
 * @return {number}
 */
proto.vnf.Account.prototype.getNumberOfAllowedNodes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setNumberOfAllowedNodes = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 number_of_allowed_employees = 10;
 * @return {number}
 */
proto.vnf.Account.prototype.getNumberOfAllowedEmployees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.Account} returns this
 */
proto.vnf.Account.prototype.setNumberOfAllowedEmployees = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ScanConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ScanConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ScanConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ScanConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && asset_task_pb.NetworkConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ScanConfig}
 */
proto.vnf.ScanConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ScanConfig;
  return proto.vnf.ScanConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ScanConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ScanConfig}
 */
proto.vnf.ScanConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new asset_task_pb.NetworkConfig;
      reader.readMessage(value,asset_task_pb.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ScanConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ScanConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ScanConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ScanConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      asset_task_pb.NetworkConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.vnf.ScanConfig.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ScanConfig} returns this
 */
proto.vnf.ScanConfig.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.vnf.ScanConfig.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ScanConfig} returns this
 */
proto.vnf.ScanConfig.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.vnf.ScanConfig.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ScanConfig} returns this
 */
proto.vnf.ScanConfig.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional asset.NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.vnf.ScanConfig.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, asset_task_pb.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.vnf.ScanConfig} returns this
*/
proto.vnf.ScanConfig.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ScanConfig} returns this
 */
proto.vnf.ScanConfig.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ScanConfig.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ContinuousScanTask.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ContinuousScanTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ContinuousScanTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTask.toObject = function(includeInstance, msg) {
  var f, obj = {
continuousScanTaskId: jspb.Message.getFieldWithDefault(msg, 1, 0),
scanConfig: (f = msg.getScanConfig()) && proto.vnf.ScanConfig.toObject(includeInstance, f),
maxHours: jspb.Message.getFieldWithDefault(msg, 3, 0),
taskId: jspb.Message.getFieldWithDefault(msg, 10, ""),
snapshotId: jspb.Message.getFieldWithDefault(msg, 11, ""),
procStatus: jspb.Message.getFieldWithDefault(msg, 12, ""),
errorMessage: jspb.Message.getFieldWithDefault(msg, 13, ""),
createdTimestamp: jspb.Message.getFieldWithDefault(msg, 14, 0),
updatedTimestamp: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ContinuousScanTask}
 */
proto.vnf.ContinuousScanTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ContinuousScanTask;
  return proto.vnf.ContinuousScanTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ContinuousScanTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ContinuousScanTask}
 */
proto.vnf.ContinuousScanTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContinuousScanTaskId(value);
      break;
    case 2:
      var value = new proto.vnf.ScanConfig;
      reader.readMessage(value,proto.vnf.ScanConfig.deserializeBinaryFromReader);
      msg.setScanConfig(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxHours(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedTimestamp(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ContinuousScanTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ContinuousScanTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ContinuousScanTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContinuousScanTaskId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getScanConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vnf.ScanConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxHours();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProcStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCreatedTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getUpdatedTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
};


/**
 * optional int64 continuous_scan_task_id = 1;
 * @return {number}
 */
proto.vnf.ContinuousScanTask.prototype.getContinuousScanTaskId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setContinuousScanTaskId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ScanConfig scan_config = 2;
 * @return {?proto.vnf.ScanConfig}
 */
proto.vnf.ContinuousScanTask.prototype.getScanConfig = function() {
  return /** @type{?proto.vnf.ScanConfig} */ (
    jspb.Message.getWrapperField(this, proto.vnf.ScanConfig, 2));
};


/**
 * @param {?proto.vnf.ScanConfig|undefined} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
*/
proto.vnf.ContinuousScanTask.prototype.setScanConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.clearScanConfig = function() {
  return this.setScanConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ContinuousScanTask.prototype.hasScanConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 max_hours = 3;
 * @return {number}
 */
proto.vnf.ContinuousScanTask.prototype.getMaxHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setMaxHours = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string task_id = 10;
 * @return {string}
 */
proto.vnf.ContinuousScanTask.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string snapshot_id = 11;
 * @return {string}
 */
proto.vnf.ContinuousScanTask.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string proc_status = 12;
 * @return {string}
 */
proto.vnf.ContinuousScanTask.prototype.getProcStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setProcStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string error_message = 13;
 * @return {string}
 */
proto.vnf.ContinuousScanTask.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 created_timestamp = 14;
 * @return {number}
 */
proto.vnf.ContinuousScanTask.prototype.getCreatedTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setCreatedTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 updated_timestamp = 15;
 * @return {number}
 */
proto.vnf.ContinuousScanTask.prototype.getUpdatedTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.ContinuousScanTask} returns this
 */
proto.vnf.ContinuousScanTask.prototype.setUpdatedTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.BoardNetwork.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.BoardNetwork.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.BoardNetwork} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.BoardNetwork.toObject = function(includeInstance, msg) {
  var f, obj = {
network: jspb.Message.getFieldWithDefault(msg, 1, ""),
locationType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.BoardNetwork}
 */
proto.vnf.BoardNetwork.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.BoardNetwork;
  return proto.vnf.BoardNetwork.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.BoardNetwork} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.BoardNetwork}
 */
proto.vnf.BoardNetwork.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetwork(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.BoardNetwork.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.BoardNetwork.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.BoardNetwork} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.BoardNetwork.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetwork();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string network = 1;
 * @return {string}
 */
proto.vnf.BoardNetwork.prototype.getNetwork = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.BoardNetwork} returns this
 */
proto.vnf.BoardNetwork.prototype.setNetwork = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_type = 2;
 * @return {string}
 */
proto.vnf.BoardNetwork.prototype.getLocationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.BoardNetwork} returns this
 */
proto.vnf.BoardNetwork.prototype.setLocationType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.UpdateListZabbixHostRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateListZabbixHostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateListZabbixHostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateListZabbixHostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
zabbixHostListList: jspb.Message.toObjectList(msg.getZabbixHostListList(),
    proto.vnf.ZabbixHost.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateListZabbixHostRequest}
 */
proto.vnf.UpdateListZabbixHostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateListZabbixHostRequest;
  return proto.vnf.UpdateListZabbixHostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateListZabbixHostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateListZabbixHostRequest}
 */
proto.vnf.UpdateListZabbixHostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = new proto.vnf.ZabbixHost;
      reader.readMessage(value,proto.vnf.ZabbixHost.deserializeBinaryFromReader);
      msg.addZabbixHostList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateListZabbixHostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateListZabbixHostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateListZabbixHostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getZabbixHostListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vnf.ZabbixHost.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateListZabbixHostRequest} returns this
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ZabbixHost zabbix_host_list = 2;
 * @return {!Array<!proto.vnf.ZabbixHost>}
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.getZabbixHostListList = function() {
  return /** @type{!Array<!proto.vnf.ZabbixHost>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.ZabbixHost, 2));
};


/**
 * @param {!Array<!proto.vnf.ZabbixHost>} value
 * @return {!proto.vnf.UpdateListZabbixHostRequest} returns this
*/
proto.vnf.UpdateListZabbixHostRequest.prototype.setZabbixHostListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vnf.ZabbixHost=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.ZabbixHost}
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.addZabbixHostList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vnf.ZabbixHost, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.UpdateListZabbixHostRequest} returns this
 */
proto.vnf.UpdateListZabbixHostRequest.prototype.clearZabbixHostListList = function() {
  return this.setZabbixHostListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.SubmitSupportInquiryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.SubmitSupportInquiryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.SubmitSupportInquiryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
service: jspb.Message.getFieldWithDefault(msg, 1, ""),
pb_abstract: jspb.Message.getFieldWithDefault(msg, 2, ""),
contents: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.SubmitSupportInquiryRequest}
 */
proto.vnf.SubmitSupportInquiryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.SubmitSupportInquiryRequest;
  return proto.vnf.SubmitSupportInquiryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.SubmitSupportInquiryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.SubmitSupportInquiryRequest}
 */
proto.vnf.SubmitSupportInquiryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setService(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbstract(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.SubmitSupportInquiryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.SubmitSupportInquiryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.SubmitSupportInquiryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getService();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAbstract();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContents();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string service = 1;
 * @return {string}
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.getService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.SubmitSupportInquiryRequest} returns this
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.setService = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string abstract = 2;
 * @return {string}
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.getAbstract = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.SubmitSupportInquiryRequest} returns this
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.setAbstract = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string contents = 3;
 * @return {string}
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.getContents = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.SubmitSupportInquiryRequest} returns this
 */
proto.vnf.SubmitSupportInquiryRequest.prototype.setContents = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ManagedNodeUserInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ManagedNodeUserInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeUserInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
managedNodeId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ManagedNodeUserInfoRequest}
 */
proto.vnf.ManagedNodeUserInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ManagedNodeUserInfoRequest;
  return proto.vnf.ManagedNodeUserInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ManagedNodeUserInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ManagedNodeUserInfoRequest}
 */
proto.vnf.ManagedNodeUserInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ManagedNodeUserInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ManagedNodeUserInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeUserInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ManagedNodeUserInfoRequest} returns this
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string managed_node_id = 2;
 * @return {string}
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.ManagedNodeUserInfoRequest} returns this
 */
proto.vnf.ManagedNodeUserInfoRequest.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateManagedNodeUserInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateManagedNodeUserInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
managedNodeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
department: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateManagedNodeUserInfoRequest;
  return proto.vnf.UpdateManagedNodeUserInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateManagedNodeUserInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManagedNodeId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateManagedNodeUserInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateManagedNodeUserInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManagedNodeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest} returns this
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string managed_node_id = 2;
 * @return {string}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.getManagedNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest} returns this
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.setManagedNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest} returns this
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string department = 5;
 * @return {string}
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateManagedNodeUserInfoRequest} returns this
 */
proto.vnf.UpdateManagedNodeUserInfoRequest.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.GetListAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.GetListAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.GetListAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.GetListAccountRequest}
 */
proto.vnf.GetListAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.GetListAccountRequest;
  return proto.vnf.GetListAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.GetListAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.GetListAccountRequest}
 */
proto.vnf.GetListAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.GetListAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.GetListAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.GetListAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vnf.GetListAccountRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.GetListAccountRequest} returns this
 */
proto.vnf.GetListAccountRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateAccountNodePrivilegeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateAccountNodePrivilegeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
nodePrivilegeUpdateListList: jspb.Message.toObjectList(msg.getNodePrivilegeUpdateListList(),
    proto.vnf.NodePrivilegeUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateAccountNodePrivilegeRequest}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateAccountNodePrivilegeRequest;
  return proto.vnf.UpdateAccountNodePrivilegeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateAccountNodePrivilegeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateAccountNodePrivilegeRequest}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new proto.vnf.NodePrivilegeUpdate;
      reader.readMessage(value,proto.vnf.NodePrivilegeUpdate.deserializeBinaryFromReader);
      msg.addNodePrivilegeUpdateList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateAccountNodePrivilegeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateAccountNodePrivilegeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNodePrivilegeUpdateListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vnf.NodePrivilegeUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateAccountNodePrivilegeRequest} returns this
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NodePrivilegeUpdate node_privilege_update_list = 2;
 * @return {!Array<!proto.vnf.NodePrivilegeUpdate>}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.getNodePrivilegeUpdateListList = function() {
  return /** @type{!Array<!proto.vnf.NodePrivilegeUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.NodePrivilegeUpdate, 2));
};


/**
 * @param {!Array<!proto.vnf.NodePrivilegeUpdate>} value
 * @return {!proto.vnf.UpdateAccountNodePrivilegeRequest} returns this
*/
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.setNodePrivilegeUpdateListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vnf.NodePrivilegeUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.NodePrivilegeUpdate}
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.addNodePrivilegeUpdateList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vnf.NodePrivilegeUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.UpdateAccountNodePrivilegeRequest} returns this
 */
proto.vnf.UpdateAccountNodePrivilegeRequest.prototype.clearNodePrivilegeUpdateListList = function() {
  return this.setNodePrivilegeUpdateListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.AccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.AccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.AccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.AccountRequest}
 */
proto.vnf.AccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.AccountRequest;
  return proto.vnf.AccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.AccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.AccountRequest}
 */
proto.vnf.AccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.AccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.AccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.AccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vnf.AccountRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.AccountRequest} returns this
 */
proto.vnf.AccountRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.CreateAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.CreateAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.CreateAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
admin: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
department: jspb.Message.getFieldWithDefault(msg, 5, ""),
superAdmin: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.CreateAccountRequest}
 */
proto.vnf.CreateAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.CreateAccountRequest;
  return proto.vnf.CreateAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.CreateAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.CreateAccountRequest}
 */
proto.vnf.CreateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdmin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuperAdmin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.CreateAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.CreateAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.CreateAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdmin();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSuperAdmin();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional bool admin = 1;
 * @return {boolean}
 */
proto.vnf.CreateAccountRequest.prototype.getAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.vnf.CreateAccountRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.vnf.CreateAccountRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.vnf.CreateAccountRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string department = 5;
 * @return {string}
 */
proto.vnf.CreateAccountRequest.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool super_admin = 6;
 * @return {boolean}
 */
proto.vnf.CreateAccountRequest.prototype.getSuperAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.CreateAccountRequest} returns this
 */
proto.vnf.CreateAccountRequest.prototype.setSuperAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
department: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateAccountRequest}
 */
proto.vnf.UpdateAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateAccountRequest;
  return proto.vnf.UpdateAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateAccountRequest}
 */
proto.vnf.UpdateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vnf.UpdateAccountRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateAccountRequest} returns this
 */
proto.vnf.UpdateAccountRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.vnf.UpdateAccountRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateAccountRequest} returns this
 */
proto.vnf.UpdateAccountRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string department = 3;
 * @return {string}
 */
proto.vnf.UpdateAccountRequest.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateAccountRequest} returns this
 */
proto.vnf.UpdateAccountRequest.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.CreateScanTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.CreateScanTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.CreateScanTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateScanTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && asset_task_pb.NetworkConfig.toObject(includeInstance, f),
maxHours: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.CreateScanTaskRequest}
 */
proto.vnf.CreateScanTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.CreateScanTaskRequest;
  return proto.vnf.CreateScanTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.CreateScanTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.CreateScanTaskRequest}
 */
proto.vnf.CreateScanTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new asset_task_pb.NetworkConfig;
      reader.readMessage(value,asset_task_pb.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxHours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.CreateScanTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.CreateScanTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.CreateScanTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateScanTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      asset_task_pb.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxHours();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.vnf.CreateScanTaskRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
 */
proto.vnf.CreateScanTaskRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.vnf.CreateScanTaskRequest.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
 */
proto.vnf.CreateScanTaskRequest.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.vnf.CreateScanTaskRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
 */
proto.vnf.CreateScanTaskRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional asset.NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.vnf.CreateScanTaskRequest.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, asset_task_pb.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
*/
proto.vnf.CreateScanTaskRequest.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
 */
proto.vnf.CreateScanTaskRequest.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.CreateScanTaskRequest.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 max_hours = 7;
 * @return {number}
 */
proto.vnf.CreateScanTaskRequest.prototype.getMaxHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.CreateScanTaskRequest} returns this
 */
proto.vnf.CreateScanTaskRequest.prototype.setMaxHours = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.GetListContinuousScanTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.GetListContinuousScanTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListContinuousScanTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pagination: (f = msg.getPagination()) && asset_util_pb.RequestPagination.toObject(includeInstance, f),
onlyProcessing: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.GetListContinuousScanTaskRequest}
 */
proto.vnf.GetListContinuousScanTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.GetListContinuousScanTaskRequest;
  return proto.vnf.GetListContinuousScanTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.GetListContinuousScanTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.GetListContinuousScanTaskRequest}
 */
proto.vnf.GetListContinuousScanTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = new asset_util_pb.RequestPagination;
      reader.readMessage(value,asset_util_pb.RequestPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlyProcessing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.GetListContinuousScanTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.GetListContinuousScanTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListContinuousScanTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      asset_util_pb.RequestPagination.serializeBinaryToWriter
    );
  }
  f = message.getOnlyProcessing();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.GetListContinuousScanTaskRequest} returns this
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional asset.RequestPagination pagination = 2;
 * @return {?proto.asset.RequestPagination}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.getPagination = function() {
  return /** @type{?proto.asset.RequestPagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.RequestPagination, 2));
};


/**
 * @param {?proto.asset.RequestPagination|undefined} value
 * @return {!proto.vnf.GetListContinuousScanTaskRequest} returns this
*/
proto.vnf.GetListContinuousScanTaskRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.GetListContinuousScanTaskRequest} returns this
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool only_processing = 3;
 * @return {boolean}
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.getOnlyProcessing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.GetListContinuousScanTaskRequest} returns this
 */
proto.vnf.GetListContinuousScanTaskRequest.prototype.setOnlyProcessing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.GetContinuousScanTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.GetContinuousScanTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetContinuousScanTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
continuousScanTaskId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.GetContinuousScanTaskRequest}
 */
proto.vnf.GetContinuousScanTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.GetContinuousScanTaskRequest;
  return proto.vnf.GetContinuousScanTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.GetContinuousScanTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.GetContinuousScanTaskRequest}
 */
proto.vnf.GetContinuousScanTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContinuousScanTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.GetContinuousScanTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.GetContinuousScanTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetContinuousScanTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContinuousScanTaskId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.GetContinuousScanTaskRequest} returns this
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 continuous_scan_task_id = 2;
 * @return {number}
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.getContinuousScanTaskId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vnf.GetContinuousScanTaskRequest} returns this
 */
proto.vnf.GetContinuousScanTaskRequest.prototype.setContinuousScanTaskId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.GetListBoardNetworkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.GetListBoardNetworkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.GetListBoardNetworkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListBoardNetworkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.GetListBoardNetworkRequest}
 */
proto.vnf.GetListBoardNetworkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.GetListBoardNetworkRequest;
  return proto.vnf.GetListBoardNetworkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.GetListBoardNetworkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.GetListBoardNetworkRequest}
 */
proto.vnf.GetListBoardNetworkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.GetListBoardNetworkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.GetListBoardNetworkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.GetListBoardNetworkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.GetListBoardNetworkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.ManagedNodeListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ManagedNodeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ManagedNodeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ManagedNodeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
nodeListList: jspb.Message.toObjectList(msg.getNodeListList(),
    proto.vnf.ManagedNodeWithStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ManagedNodeListResponse}
 */
proto.vnf.ManagedNodeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ManagedNodeListResponse;
  return proto.vnf.ManagedNodeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ManagedNodeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ManagedNodeListResponse}
 */
proto.vnf.ManagedNodeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.vnf.ManagedNodeWithStatus;
      reader.readMessage(value,proto.vnf.ManagedNodeWithStatus.deserializeBinaryFromReader);
      msg.addNodeList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ManagedNodeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ManagedNodeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ManagedNodeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getNodeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vnf.ManagedNodeWithStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional asset.ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.vnf.ManagedNodeListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.vnf.ManagedNodeListResponse} returns this
*/
proto.vnf.ManagedNodeListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ManagedNodeListResponse} returns this
 */
proto.vnf.ManagedNodeListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ManagedNodeListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ManagedNodeWithStatus node_list = 2;
 * @return {!Array<!proto.vnf.ManagedNodeWithStatus>}
 */
proto.vnf.ManagedNodeListResponse.prototype.getNodeListList = function() {
  return /** @type{!Array<!proto.vnf.ManagedNodeWithStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.ManagedNodeWithStatus, 2));
};


/**
 * @param {!Array<!proto.vnf.ManagedNodeWithStatus>} value
 * @return {!proto.vnf.ManagedNodeListResponse} returns this
*/
proto.vnf.ManagedNodeListResponse.prototype.setNodeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vnf.ManagedNodeWithStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.ManagedNodeWithStatus}
 */
proto.vnf.ManagedNodeListResponse.prototype.addNodeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vnf.ManagedNodeWithStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.ManagedNodeListResponse} returns this
 */
proto.vnf.ManagedNodeListResponse.prototype.clearNodeListList = function() {
  return this.setNodeListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateListZabbixHostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateListZabbixHostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateListZabbixHostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateListZabbixHostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
unavailable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateListZabbixHostResponse}
 */
proto.vnf.UpdateListZabbixHostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateListZabbixHostResponse;
  return proto.vnf.UpdateListZabbixHostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateListZabbixHostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateListZabbixHostResponse}
 */
proto.vnf.UpdateListZabbixHostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnavailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateListZabbixHostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateListZabbixHostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateListZabbixHostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateListZabbixHostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnavailable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool unavailable = 1;
 * @return {boolean}
 */
proto.vnf.UpdateListZabbixHostResponse.prototype.getUnavailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vnf.UpdateListZabbixHostResponse} returns this
 */
proto.vnf.UpdateListZabbixHostResponse.prototype.setUnavailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ManagedNodeUserInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ManagedNodeUserInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ManagedNodeUserInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeUserInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
userInfo: (f = msg.getUserInfo()) && proto.vnf.UserInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ManagedNodeUserInfoResponse}
 */
proto.vnf.ManagedNodeUserInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ManagedNodeUserInfoResponse;
  return proto.vnf.ManagedNodeUserInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ManagedNodeUserInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ManagedNodeUserInfoResponse}
 */
proto.vnf.ManagedNodeUserInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.UserInfo;
      reader.readMessage(value,proto.vnf.UserInfo.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ManagedNodeUserInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ManagedNodeUserInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ManagedNodeUserInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ManagedNodeUserInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vnf.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserInfo user_info = 1;
 * @return {?proto.vnf.UserInfo}
 */
proto.vnf.ManagedNodeUserInfoResponse.prototype.getUserInfo = function() {
  return /** @type{?proto.vnf.UserInfo} */ (
    jspb.Message.getWrapperField(this, proto.vnf.UserInfo, 1));
};


/**
 * @param {?proto.vnf.UserInfo|undefined} value
 * @return {!proto.vnf.ManagedNodeUserInfoResponse} returns this
*/
proto.vnf.ManagedNodeUserInfoResponse.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ManagedNodeUserInfoResponse} returns this
 */
proto.vnf.ManagedNodeUserInfoResponse.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ManagedNodeUserInfoResponse.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.NodePrivilegeListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.NodePrivilegeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.NodePrivilegeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.NodePrivilegeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nodePrivilegeListList: jspb.Message.toObjectList(msg.getNodePrivilegeListList(),
    proto.vnf.NodePrivilege.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.NodePrivilegeListResponse}
 */
proto.vnf.NodePrivilegeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.NodePrivilegeListResponse;
  return proto.vnf.NodePrivilegeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.NodePrivilegeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.NodePrivilegeListResponse}
 */
proto.vnf.NodePrivilegeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.NodePrivilege;
      reader.readMessage(value,proto.vnf.NodePrivilege.deserializeBinaryFromReader);
      msg.addNodePrivilegeList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.NodePrivilegeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.NodePrivilegeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.NodePrivilegeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodePrivilegeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vnf.NodePrivilege.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NodePrivilege node_privilege_list = 1;
 * @return {!Array<!proto.vnf.NodePrivilege>}
 */
proto.vnf.NodePrivilegeListResponse.prototype.getNodePrivilegeListList = function() {
  return /** @type{!Array<!proto.vnf.NodePrivilege>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.NodePrivilege, 1));
};


/**
 * @param {!Array<!proto.vnf.NodePrivilege>} value
 * @return {!proto.vnf.NodePrivilegeListResponse} returns this
*/
proto.vnf.NodePrivilegeListResponse.prototype.setNodePrivilegeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vnf.NodePrivilege=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.NodePrivilege}
 */
proto.vnf.NodePrivilegeListResponse.prototype.addNodePrivilegeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vnf.NodePrivilege, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.NodePrivilegeListResponse} returns this
 */
proto.vnf.NodePrivilegeListResponse.prototype.clearNodePrivilegeListList = function() {
  return this.setNodePrivilegeListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.NodePrivilegeUpdateResultListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.NodePrivilegeUpdateResultListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nodePrivilegeUpdateResultListList: jspb.Message.toObjectList(msg.getNodePrivilegeUpdateResultListList(),
    proto.vnf.NodePrivilegeUpdateResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.NodePrivilegeUpdateResultListResponse}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.NodePrivilegeUpdateResultListResponse;
  return proto.vnf.NodePrivilegeUpdateResultListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.NodePrivilegeUpdateResultListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.NodePrivilegeUpdateResultListResponse}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.NodePrivilegeUpdateResult;
      reader.readMessage(value,proto.vnf.NodePrivilegeUpdateResult.deserializeBinaryFromReader);
      msg.addNodePrivilegeUpdateResultList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.NodePrivilegeUpdateResultListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.NodePrivilegeUpdateResultListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodePrivilegeUpdateResultListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vnf.NodePrivilegeUpdateResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NodePrivilegeUpdateResult node_privilege_update_result_list = 1;
 * @return {!Array<!proto.vnf.NodePrivilegeUpdateResult>}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.getNodePrivilegeUpdateResultListList = function() {
  return /** @type{!Array<!proto.vnf.NodePrivilegeUpdateResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.NodePrivilegeUpdateResult, 1));
};


/**
 * @param {!Array<!proto.vnf.NodePrivilegeUpdateResult>} value
 * @return {!proto.vnf.NodePrivilegeUpdateResultListResponse} returns this
*/
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.setNodePrivilegeUpdateResultListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vnf.NodePrivilegeUpdateResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.NodePrivilegeUpdateResult}
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.addNodePrivilegeUpdateResultList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vnf.NodePrivilegeUpdateResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.NodePrivilegeUpdateResultListResponse} returns this
 */
proto.vnf.NodePrivilegeUpdateResultListResponse.prototype.clearNodePrivilegeUpdateResultListList = function() {
  return this.setNodePrivilegeUpdateResultListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.AccountListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.AccountListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.AccountListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.AccountListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
accountListList: jspb.Message.toObjectList(msg.getAccountListList(),
    proto.vnf.Account.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.AccountListResponse}
 */
proto.vnf.AccountListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.AccountListResponse;
  return proto.vnf.AccountListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.AccountListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.AccountListResponse}
 */
proto.vnf.AccountListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.Account;
      reader.readMessage(value,proto.vnf.Account.deserializeBinaryFromReader);
      msg.addAccountList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.AccountListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.AccountListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.AccountListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vnf.Account.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Account account_list = 1;
 * @return {!Array<!proto.vnf.Account>}
 */
proto.vnf.AccountListResponse.prototype.getAccountListList = function() {
  return /** @type{!Array<!proto.vnf.Account>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.Account, 1));
};


/**
 * @param {!Array<!proto.vnf.Account>} value
 * @return {!proto.vnf.AccountListResponse} returns this
*/
proto.vnf.AccountListResponse.prototype.setAccountListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vnf.Account=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.Account}
 */
proto.vnf.AccountListResponse.prototype.addAccountList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vnf.Account, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.AccountListResponse} returns this
 */
proto.vnf.AccountListResponse.prototype.clearAccountListList = function() {
  return this.setAccountListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.AccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.AccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.AccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
account: (f = msg.getAccount()) && proto.vnf.Account.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.AccountResponse}
 */
proto.vnf.AccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.AccountResponse;
  return proto.vnf.AccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.AccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.AccountResponse}
 */
proto.vnf.AccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.Account;
      reader.readMessage(value,proto.vnf.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.AccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.AccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.AccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.AccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vnf.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.vnf.Account}
 */
proto.vnf.AccountResponse.prototype.getAccount = function() {
  return /** @type{?proto.vnf.Account} */ (
    jspb.Message.getWrapperField(this, proto.vnf.Account, 1));
};


/**
 * @param {?proto.vnf.Account|undefined} value
 * @return {!proto.vnf.AccountResponse} returns this
*/
proto.vnf.AccountResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.AccountResponse} returns this
 */
proto.vnf.AccountResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.AccountResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.CreateAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.CreateAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.CreateAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
account: (f = msg.getAccount()) && proto.vnf.Account.toObject(includeInstance, f),
errorMessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.CreateAccountResponse}
 */
proto.vnf.CreateAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.CreateAccountResponse;
  return proto.vnf.CreateAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.CreateAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.CreateAccountResponse}
 */
proto.vnf.CreateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.Account;
      reader.readMessage(value,proto.vnf.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.CreateAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.CreateAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.CreateAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.CreateAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vnf.Account.serializeBinaryToWriter
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.vnf.Account}
 */
proto.vnf.CreateAccountResponse.prototype.getAccount = function() {
  return /** @type{?proto.vnf.Account} */ (
    jspb.Message.getWrapperField(this, proto.vnf.Account, 1));
};


/**
 * @param {?proto.vnf.Account|undefined} value
 * @return {!proto.vnf.CreateAccountResponse} returns this
*/
proto.vnf.CreateAccountResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.CreateAccountResponse} returns this
 */
proto.vnf.CreateAccountResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.CreateAccountResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.vnf.CreateAccountResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.CreateAccountResponse} returns this
 */
proto.vnf.CreateAccountResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.UpdateAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.UpdateAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.UpdateAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
errorMessage: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.UpdateAccountResponse}
 */
proto.vnf.UpdateAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.UpdateAccountResponse;
  return proto.vnf.UpdateAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.UpdateAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.UpdateAccountResponse}
 */
proto.vnf.UpdateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.UpdateAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.UpdateAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.UpdateAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.UpdateAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error_message = 1;
 * @return {string}
 */
proto.vnf.UpdateAccountResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vnf.UpdateAccountResponse} returns this
 */
proto.vnf.UpdateAccountResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.ContinuousScanTaskListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ContinuousScanTaskListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ContinuousScanTaskListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTaskListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
continuousScanTaskListList: jspb.Message.toObjectList(msg.getContinuousScanTaskListList(),
    proto.vnf.ContinuousScanTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ContinuousScanTaskListResponse}
 */
proto.vnf.ContinuousScanTaskListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ContinuousScanTaskListResponse;
  return proto.vnf.ContinuousScanTaskListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ContinuousScanTaskListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ContinuousScanTaskListResponse}
 */
proto.vnf.ContinuousScanTaskListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.vnf.ContinuousScanTask;
      reader.readMessage(value,proto.vnf.ContinuousScanTask.deserializeBinaryFromReader);
      msg.addContinuousScanTaskList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ContinuousScanTaskListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ContinuousScanTaskListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTaskListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getContinuousScanTaskListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vnf.ContinuousScanTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional asset.ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.vnf.ContinuousScanTaskListResponse} returns this
*/
proto.vnf.ContinuousScanTaskListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ContinuousScanTaskListResponse} returns this
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ContinuousScanTask continuous_scan_task_list = 2;
 * @return {!Array<!proto.vnf.ContinuousScanTask>}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.getContinuousScanTaskListList = function() {
  return /** @type{!Array<!proto.vnf.ContinuousScanTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.ContinuousScanTask, 2));
};


/**
 * @param {!Array<!proto.vnf.ContinuousScanTask>} value
 * @return {!proto.vnf.ContinuousScanTaskListResponse} returns this
*/
proto.vnf.ContinuousScanTaskListResponse.prototype.setContinuousScanTaskListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vnf.ContinuousScanTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.ContinuousScanTask}
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.addContinuousScanTaskList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vnf.ContinuousScanTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.ContinuousScanTaskListResponse} returns this
 */
proto.vnf.ContinuousScanTaskListResponse.prototype.clearContinuousScanTaskListList = function() {
  return this.setContinuousScanTaskListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.ContinuousScanTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.ContinuousScanTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.ContinuousScanTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
continuousScanTask: (f = msg.getContinuousScanTask()) && proto.vnf.ContinuousScanTask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.ContinuousScanTaskResponse}
 */
proto.vnf.ContinuousScanTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.ContinuousScanTaskResponse;
  return proto.vnf.ContinuousScanTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.ContinuousScanTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.ContinuousScanTaskResponse}
 */
proto.vnf.ContinuousScanTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.ContinuousScanTask;
      reader.readMessage(value,proto.vnf.ContinuousScanTask.deserializeBinaryFromReader);
      msg.setContinuousScanTask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.ContinuousScanTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.ContinuousScanTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.ContinuousScanTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.ContinuousScanTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContinuousScanTask();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vnf.ContinuousScanTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContinuousScanTask continuous_scan_task = 1;
 * @return {?proto.vnf.ContinuousScanTask}
 */
proto.vnf.ContinuousScanTaskResponse.prototype.getContinuousScanTask = function() {
  return /** @type{?proto.vnf.ContinuousScanTask} */ (
    jspb.Message.getWrapperField(this, proto.vnf.ContinuousScanTask, 1));
};


/**
 * @param {?proto.vnf.ContinuousScanTask|undefined} value
 * @return {!proto.vnf.ContinuousScanTaskResponse} returns this
*/
proto.vnf.ContinuousScanTaskResponse.prototype.setContinuousScanTask = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vnf.ContinuousScanTaskResponse} returns this
 */
proto.vnf.ContinuousScanTaskResponse.prototype.clearContinuousScanTask = function() {
  return this.setContinuousScanTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vnf.ContinuousScanTaskResponse.prototype.hasContinuousScanTask = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vnf.BoardNetworkListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vnf.BoardNetworkListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vnf.BoardNetworkListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vnf.BoardNetworkListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.BoardNetworkListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
boardNetworkListList: jspb.Message.toObjectList(msg.getBoardNetworkListList(),
    proto.vnf.BoardNetwork.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vnf.BoardNetworkListResponse}
 */
proto.vnf.BoardNetworkListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vnf.BoardNetworkListResponse;
  return proto.vnf.BoardNetworkListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vnf.BoardNetworkListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vnf.BoardNetworkListResponse}
 */
proto.vnf.BoardNetworkListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vnf.BoardNetwork;
      reader.readMessage(value,proto.vnf.BoardNetwork.deserializeBinaryFromReader);
      msg.addBoardNetworkList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vnf.BoardNetworkListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vnf.BoardNetworkListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vnf.BoardNetworkListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vnf.BoardNetworkListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardNetworkListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vnf.BoardNetwork.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BoardNetwork board_network_list = 1;
 * @return {!Array<!proto.vnf.BoardNetwork>}
 */
proto.vnf.BoardNetworkListResponse.prototype.getBoardNetworkListList = function() {
  return /** @type{!Array<!proto.vnf.BoardNetwork>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vnf.BoardNetwork, 1));
};


/**
 * @param {!Array<!proto.vnf.BoardNetwork>} value
 * @return {!proto.vnf.BoardNetworkListResponse} returns this
*/
proto.vnf.BoardNetworkListResponse.prototype.setBoardNetworkListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vnf.BoardNetwork=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vnf.BoardNetwork}
 */
proto.vnf.BoardNetworkListResponse.prototype.addBoardNetworkList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vnf.BoardNetwork, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vnf.BoardNetworkListResponse} returns this
 */
proto.vnf.BoardNetworkListResponse.prototype.clearBoardNetworkListList = function() {
  return this.setBoardNetworkListList([]);
};


goog.object.extend(exports, proto.vnf);
